module.exports = __webpack_public_path__ + "img/golf-1.4ece46a7.png";